import { Form, Modal, Select, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { TriggerResponseDto } from '@evimo/client/models';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button';
import { TriggersConditionFormList } from './components/TriggersConditionFormList/TriggersConditionFormList';
import { useTriggersTab } from './hooks/useTriggersTab';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

export function TriggersTab() {
  const { t } = useTranslation('maintenance');
  const {
    triggers,
    isLoading,
    columns,
    modalOpen,
    form,
    openCreate,
    closeModal,
    handleCreate,
    isCreating,
    basisOptions,
    conditionTypeOptions,
  } = useTriggersTab();

  return (
    <>
      <Space
        style={{ width: '100%', justifyContent: 'flex-end', marginBottom: 16 }}
      >
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>
          {t('triggers.create')}
        </Button>
      </Space>
      <EvimoTable<TriggerResponseDto>
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={triggers}
        pagination={{ pageSize: 10, showSizeChanger: true }}
        size="middle"
      />

      <Modal
        open={modalOpen}
        title={t('triggers.createTitle')}
        onCancel={closeModal}
        onOk={() => void handleCreate()}
        confirmLoading={isCreating}
        destroyOnClose
        width={600}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="basis"
            label={t('triggers.basis')}
            rules={[{ required: true }]}
          >
            <Select
              options={basisOptions}
              placeholder={t('triggers.selectBasis')}
            />
          </Form.Item>
          <TriggersConditionFormList
            form={form}
            conditionTypeOptions={conditionTypeOptions}
          />
        </Form>
      </Modal>
    </>
  );
}
